<template>
   <div class="col row">
      <div v-if="detail.code!='MAC'" class="col-1 p-0">
         <userCircle :circleUser="circleUser"/>
      </div>
      <div class="col-11 fs-14 p-0 ps-2">
         <div class="row ps-1">
            <div class="ps-1">
               <div v-if="detail.code=='SML'"> 
                  <b>{{circleUser.name}}</b>
                  ha enviado el mail de 
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='RMV'"> 
                  <b>{{circleUser.name}}</b>
                  ha movido esta tarjeta de 
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='UMS'"> 
                  <b>{{circleUser.name}}</b>
                  ha regresado esta tarjeta desde 
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='SHR'"> 
                  <b>{{circleUser.name}}</b>
                  ha compartido esta tarjeta desde 
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='USH'"> 
                  <b>{{circleUser.name}}</b>
                  ha finalizado la intervención de esta tarjeta en
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='NEW'"> 
                  <b>{{circleUser.name}}</b>
                  ha iniciado esta tarjeta en la lista   
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='DOK'"> 
                  <b>{{circleUser.name}}</b>
                  ha marcado las fechas como    
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='DOF'"> 
                  <b>{{circleUser.name}}</b>
                  ha eliminado las fechas
               </div>
               <div v-if="detail.code=='DON'"> 
                  <b>{{circleUser.name}}</b>
                  ha establecido las fechas desde el      
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='CHL'"> 
                  <b>{{circleUser.name}}</b>
                  ha       
                  {{detail.description}}      
                  las listas de control
               </div>
               <!--
               <div v-if="detail.code=='CRL'"> 
                  <b>{{circleUser.name}}</b>
                  {{detail.description}}
               </div>
               -->
               <div v-if="'.CRL.LBL.CPY.TTL.VLD.AUT.'.indexOf(detail.code)>-1"> 
                  <b>{{circleUser.name}}</b>
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='ATU'"> 
                  <b>{{circleUser.name}}</b>
                  ha adjuntado   
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='ATD'"> 
                  <b>{{circleUser.name}}</b>
                  ha borrado el adjunto   
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='ATP'"> 
                  <b>{{circleUser.name}}</b>
                  ha quitado el adjunto   
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='ATR'"> 
                  <b>{{circleUser.name}}</b>
                  ha recuperado el adjunto   
                  {{detail.description}}
               </div>
               <div v-if="detail.code=='AMC'"> 
                  <b>{{circleUser.name}}</b>
                  ha convocado a participar a 
                  {{detail.description}}
               </div>
               <!--
               <div v-if="detail.code=='MAC'"> 
                  <b>{{circleUser.name}}</b>
                  fue convocado a participar por  
                  {{detail.description}}
               </div>
               -->
               <div v-if="detail.code=='CMM'" class="row row-cols-auto"> 
                  <div class="col">
                     <b>{{circleUser.name}}</b>
                  </div>
                  <div class="col fs-13">
                     {{dateTime}}
                  </div>
               </div>
            </div>
         </div>
         <div class="col row ps-1 fs-13">
            <div v-if="detail.code!='CMM' && detail.code!='MAC'" class="px-1">
               {{dateTime}}
            </div>
            <div v-if="detail.code=='CMM'" class="px-1">
               <textarea 
               v-model="description"
               class="form-control bg-light tc-d-gray fs-14" 
               rows="1"
               readonly
               @click="autoSize($event)" 
               >
               </textarea>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { ref , computed} from 'vue';
import userCircle from '/src/components/UserCircle.vue';

export default {
   components: {
      userCircle
   },
   props: {
      detail: Object,
      circleUser: Object,
      dateTime: String
   },
   
   setup (props) {
      const description = computed(() => {
         return props.detail.description
      } )
      //const description = ref(props.detail.description)
      const isAuto = ref(true);

      function autoSize(event) {
         let area = event.target;
         if (isAuto.value) {
            area.style.overflow = 'hidden';
            area.style.height = area.scrollHeight + 'px';
         } else {
            area.style.overflow = 'auto';
            area.style.height = '52px';
         }
         isAuto.value = !isAuto.value
      }

      return { 
         autoSize,
         description
      }
   }
   
}
</script>

<style scoped>
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
</style>
